module.exports = __webpack_public_path__ + "static/media/sj_background.f5555922.png";